import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue / Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export default api;
